/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterCookieEditCookiePost } from '../fn/cookie/api-master-cookie-edit-cookie-post';
import { ApiMasterCookieEditCookiePost$Params } from '../fn/cookie/api-master-cookie-edit-cookie-post';
import { apiMasterCookieGetCookieGet } from '../fn/cookie/api-master-cookie-get-cookie-get';
import { ApiMasterCookieGetCookieGet$Params } from '../fn/cookie/api-master-cookie-get-cookie-get';
import { apiMasterCookieSaveCookieFeedbackPost } from '../fn/cookie/api-master-cookie-save-cookie-feedback-post';
import { ApiMasterCookieSaveCookieFeedbackPost$Params } from '../fn/cookie/api-master-cookie-save-cookie-feedback-post';
import { Cookie } from '../models/cookie';
import { CookieApiRespModel } from '../models/cookie-api-resp-model';
import { CookieFeedbackApiRespModel } from '../models/cookie-feedback-api-resp-model';

@Injectable({ providedIn: 'root' })
export class CookieService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterCookieEditCookiePost()` */
  static readonly ApiMasterCookieEditCookiePostPath = '/api/Master/Cookie/EditCookie';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCookieEditCookiePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCookieEditCookiePost$Response(params?: ApiMasterCookieEditCookiePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CookieApiRespModel>> {
    return apiMasterCookieEditCookiePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCookieEditCookiePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCookieEditCookiePost(params?: ApiMasterCookieEditCookiePost$Params, context?: HttpContext): Observable<CookieApiRespModel> {
    return this.apiMasterCookieEditCookiePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CookieApiRespModel>): CookieApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCookieSaveCookieFeedbackPost()` */
  static readonly ApiMasterCookieSaveCookieFeedbackPostPath = '/api/Master/Cookie/SaveCookieFeedback';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCookieSaveCookieFeedbackPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCookieSaveCookieFeedbackPost$Response(params?: ApiMasterCookieSaveCookieFeedbackPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CookieFeedbackApiRespModel>> {
    return apiMasterCookieSaveCookieFeedbackPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCookieSaveCookieFeedbackPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCookieSaveCookieFeedbackPost(params?: ApiMasterCookieSaveCookieFeedbackPost$Params, context?: HttpContext): Observable<CookieFeedbackApiRespModel> {
    return this.apiMasterCookieSaveCookieFeedbackPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CookieFeedbackApiRespModel>): CookieFeedbackApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCookieGetCookieGet()` */
  static readonly ApiMasterCookieGetCookieGetPath = '/api/Master/Cookie/GetCookie';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCookieGetCookieGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCookieGetCookieGet$Response(params?: ApiMasterCookieGetCookieGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Cookie>> {
    return apiMasterCookieGetCookieGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCookieGetCookieGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCookieGetCookieGet(params?: ApiMasterCookieGetCookieGet$Params, context?: HttpContext): Observable<Cookie> {
    return this.apiMasterCookieGetCookieGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Cookie>): Cookie => r.body)
    );
  }

}
